
  import { mapGetters } from 'vuex'
  import Draggable from 'vuedraggable'

  import { STORE_GRID_TYPES } from '@loavies/c2c-models'

  import AppButton from '@loavies/component-library/dist/app-button'

  export default {
    components: {
      Draggable,
      AppButton,
    },
    props: {
      listings: {
        type: Array,
        default: () => [],
      },
      gridType: {
        type: String,
        default: 'default',
        validator(value) {
          return !value || Object.values(STORE_GRID_TYPES).includes(value)
        },
      },
      showLoadMoreListingsButton: {
        type: Boolean,
        default: false,
      },
      showTransactionState: {
        type: Boolean,
        default: false,
      },
      showAuthor: {
        type: Boolean,
        default: false,
      },
      redirectToAccountListings: {
        type: Boolean,
        default: false,
      },
      showMenu: {
        type: Boolean,
        default: false,
      },
      draggable: {
        type: Boolean,
        default: false,
      },
      showLargeProductCards: {
        type: Boolean,
        default: false,
      },
      fullWidth: {
        type: Boolean,
        default: false,
      },
    },
    emits: [
      'load-more-listings',
      'update-listings',
      'update-listing-shop-index',
    ],
    data() {
      return {
        listingsToShow: [],
      }
    },
    computed: {
      ...mapGetters({
        getTransactionByListingId: 'transactions/getTransactionByListingId',
      }),
      wrapperComponent() {
        return this.draggable ? 'draggable' : 'div'
      },
      wrapperBindings() {
        if (this.draggable) {
          return {
            animation: 200,
            options: {
              forceFallback: true,
              fallbackClass: 'listings-view__listing-card--dragged',
            },
            ghostClass: 'listings-view__listing-card--ghost',
          }
        }

        return {}
      },
    },
    watch: {
      listings: {
        immediate: true,
        handler() {
          this.listingsToShow = [...this.listings]
        },
      },
    },
    methods: {
      handleLoadMore() {
        this.$emit('load-more-listings')
      },
      handleMove(event) {
        // Moving items to the last index can cause a bug
        // https://github.com/SortableJS/Sortable/issues/2011
        const newIndex = Math.min(event.newIndex, this.listingsToShow.length - 1)

        this.$emit('update-listing-shop-index', {
          id: this.listingsToShow[newIndex].id,
          shopIndex: this.getNewShopIndex(newIndex),
        })
      },
      getNewShopIndex(newIndex) {
        // First index
        if (newIndex === 0) {
          return new Date().getTime()
        }

        const shopIndexBefore = this.listingsToShow[newIndex - 1].publicData.shopIndex

        // Last index
        if (newIndex === this.listingsToShow.length - 1) {
          return shopIndexBefore - 100000000
        }

        const shopIndexAfter = this.listingsToShow[newIndex + 1].publicData.shopIndex

        return Math.ceil((shopIndexBefore + shopIndexAfter) / 2)
      },
    },
  }
